import React from "react";
import { handleAddRemove } from "../../../util/compare_utils";
import { FixedIcon } from "../../../atoms/icons/fixed";
import { ArmIcon } from "../../../atoms/icons/arm";
import { dollarFormatter } from "../../../util/dollarFormatter";
import { addTrailingZeroes } from "../../../util/addTrailingZeroes";
import CheckIcon from "@mui/icons-material/Check";

export const DataCard = ({
  quote,
  isComparedIds,
  setComparedId,
  setDetails,
}) => {
  const {
    amortizationType,
    armFixedTermYears,
    loanTerm,
    apr,
    rate,
    monthlyPayment,
    closingCosts,
    id,
  } = quote;

  const handleView = (e) => {
    e.stopPropagation();
    setDetails(id);
  };

  return (
    <div
      className={`data-card ${
        isComparedIds.includes(id) ? "compared-grid" : ""
      }`}
      onClick={() => handleAddRemove({ isComparedIds, setComparedId, id })}
    >
      <div className="data-card-border-container" />
      <div className="data-card-left">
        <div className="data-card-left-top">
          <div
            className={`${
              !armFixedTermYears ? "fixed-loan" : "fixed-loan arm-loan"
            }`}
          >
            {!armFixedTermYears ? (
              <FixedIcon fill="white" width="16px" height="16px" />
            ) : (
              <ArmIcon fill="white" width="16px" height="16px" />
            )}
            {amortizationType}
          </div>
          <div
            className={`${
              !armFixedTermYears ? "thirty-year" : "thirty-year arm-year"
            }`}
          >
            {!armFixedTermYears ? `${loanTerm} Year` : `${armFixedTermYears}/6`}
          </div>
        </div>
        <div className="data-card-left-bottom">
          <div className="monthly-payment">
            <span
              className={`monthly-payment-amount ${
                armFixedTermYears && "arm-card-color"
              }`}
            >
              {dollarFormatter(Math.round(monthlyPayment))}
            </span>
            <span className="small-font bold">Monthly payment</span>
          </div>
          <div className="closing-cost">
            <span
              className={`closing-cost-amount ${
                armFixedTermYears && "arm-card-color"
              }`}
            >
              {dollarFormatter(Math.round(closingCosts))}
            </span>
            <span className="small-font bold">Closing costs</span>
          </div>
        </div>
      </div>
      <div className="data-card-right">
        <div className="data-card-right-top">
          <span className={`bold ${armFixedTermYears && "arm-card-color"}`}>
            {addTrailingZeroes(rate)}%
          </span>
          <span className="bold small-font">Rate</span>
          <span className={`bold ${armFixedTermYears && "arm-card-color"}`}>
            {addTrailingZeroes(apr)}%
          </span>
          <span className="bold small-font">APR</span>
        </div>
        <div className="data-card-right-bottom" onClick={handleView}>
          View Details
        </div>
      </div>
      <div
        onClick={() => handleAddRemove({ isComparedIds, setComparedId, id })}
        className="added-grid-button"
      >
        {isComparedIds.includes(id) && (
          <div className="checked-icon-wrapper-grid">
            <CheckIcon sx={{ color: "white" }} fontSize="small" />
          </div>
        )}
      </div>
    </div>
  );
};
